import { TableCell, TableRow } from "@mui/material"

export default function ComputedRow({ label, value, unit }: { label: string; value: number; unit?: string }) {
    return (
        <TableRow>
            <TableCell variant="head" sx={{ width: "35%", whiteSpace: "nowrap" }}>{label}</TableCell>
            <TableCell>{Number(value).toFixed(2)}{unit ? ` ${unit}` : ""}</TableCell>
        </TableRow>
    )
}
